<template>
    <div class="container" v-if="show">
        <div class="anim">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="progress">{{ progress }}</div>
    </div>
</template>

<script>

export default {
    props: {
        show: {
            type: Boolean,
            default: false
        },
        progress: {
            type: Number,
            default: 0
        }
    }
}

</script>


<style lang="scss" scoped>
@keyframes grow {

    0%,
    100% {
        transform: scaleY(1);
    }

    50% {
        transform: scaleY(2);
    }
}

.container {
    .anim {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: space-between;
        width: 2em;

        span {
            width: 0.3em;
            height: 1em;
            background-color: #0a3078;
        }

        span:nth-of-type(1) {
            animation: grow 1s -0.45s ease-in-out infinite;
        }

        span:nth-of-type(2) {
            animation: grow 1s -0.3s ease-in-out infinite;
        }

        span:nth-of-type(3) {
            animation: grow 1s -0.15s ease-in-out infinite;
        }

        span:nth-of-type(4) {
            animation: grow 1s ease-in-out infinite;
        }
    }

    .progress {
        text-align: center;
        margin-top: 12px;
        font-size: 12px;
        transform: scale(0.8);
    }
}
</style>
